import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaiairporttolonavalacab() {



  const cardData = {
    keyword: " Navi Mumbai Airport to Lonavala Cabs   ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai Airport to Lonavala cab service, providing safe, comfortable, and affordable intercity and hill-station travel for families, couples, tourists, and business travelers. The distance between Navi Mumbai Airport and Lonavala is approximately 90–110 km, making it a smooth and scenic highway journey via express routes. Our professional drivers ensure punctual airport pickup, luggage assistance, and a stress-free travel experience with well-maintained vehicles. We offer flexible options including one-way drops, round trips, weekend getaways, and customized travel plans. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is your trusted choice for Navi Mumbai Airport to Lonavala cab service.",

"topPlaces": [
  {
    "title": "Tiger’s Point (Tiger Valley)",
    "description": "Tiger’s Point is one of the most famous viewpoints in Lonavala offering breathtaking views of deep valleys, misty hills, and lush green landscapes. It is especially popular during monsoon season when clouds float below the viewpoint, creating a magical scenic experience for travelers arriving from Navi Mumbai Airport."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is a popular monsoon attraction known for its overflowing steps and water streams. Tourists enjoy sitting on the stone steps and experiencing flowing water surrounded by greenery, making it a must-visit spot for families and groups visiting Lonavala."
  },
  {
    "title": "Lonavala Lake",
    "description": "Lonavala Lake is a peaceful waterbody surrounded by hills and greenery, ideal for relaxation, photography, and birdwatching. It is a calm retreat for travelers after a long journey from the airport."
  },
  {
    "title": "Karla Caves",
    "description": "Karla Caves are ancient Buddhist rock-cut caves known for their historical significance and intricate carvings. The caves feature one of the largest prayer halls in India and offer a blend of history, spirituality, and architecture."
  },
  {
    "title": "Bhaja Caves",
    "description": "Bhaja Caves are another set of ancient rock-cut caves located near Lonavala, famous for their Buddhist stupas and carvings. They are less crowded than Karla Caves and provide a peaceful historical exploration experience."
  },
  {
    "title": "Lion’s Point",
    "description": "Lion’s Point is a scenic viewpoint offering panoramic views of valleys, waterfalls, and mountains. It is a favorite spot for sunset viewing and photography, especially during monsoon when the surroundings are lush and misty."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic hill fort popular among trekkers and adventure seekers. It offers stunning views of the Sahyadri mountains and is one of the most adventurous attractions near Lonavala."
  },
  {
    "title": "Wax Museum Lonavala",
    "description": "The Lonavala Wax Museum features lifelike statues of famous personalities and cultural icons. It is a family-friendly attraction that adds entertainment value to the hill station visit."
  },
  {
    "title": "Kune Waterfalls",
    "description": "Kune Waterfalls is a beautiful three-tier waterfall located between Lonavala and Khandala. It is one of the highest waterfalls in Maharashtra and is especially scenic during monsoon season."
  },
  {
    "title": "Khandala Viewpoints",
    "description": "Khandala viewpoints offer stunning valley views and are located just a short drive from Lonavala. They are perfect for quick stops, photography, and enjoying the natural beauty of the Western Ghats."
  }
],






services: [
  {
    name: "Navi Mumbai to Lonavala Cab",
    description: "Navi Mumbai to Lonavala cab service offers a comfortable and scenic journey to the popular hill station. Ideal for weekend trips, family outings, and couples, this service ensures smooth travel through expressways and ghats. Professional drivers and clean vehicles enhance comfort. It guarantees a relaxing travel experience."
  },
  {
    name: "Navi Mumbai to Lonavala Cab Fare",
    description: "Navi Mumbai to Lonavala cab fare is designed to be transparent and affordable based on vehicle type and trip duration. Customers receive clear pricing before booking. No hidden charges ensure trust. It helps in planning travel budget efficiently."
  },
  {
    name: "Navi Mumbai Airport to Lonavala Cabs",
    description: "Navi Mumbai airport to Lonavala cabs provide direct transfers from airport terminals to Lonavala. Ideal for travelers arriving by flight, this service ensures timely pickup and smooth travel. Comfortable vehicles enhance the journey. It guarantees convenience."
  },
  {
    name: "Navi Mumbai Airport to Lonavala Cab",
    description: "Navi Mumbai airport to Lonavala cab offers seamless travel with door-to-door pickup from airport arrivals. This service is perfect for quick transfers to the hill station. Professional drivers ensure safety. It ensures a hassle-free journey."
  },
  {
    name: "Navi Mumbai Airport to Lonavala Taxi",
    description: "Navi Mumbai airport to Lonavala taxi provides private and flexible travel options for individuals and groups. Comfortable seating ensures a pleasant ride. Ideal for both leisure and business travel. It guarantees a reliable journey."
  },
  {
    name: "Cab from Navi Mumbai Airport to Lonavala",
    description: "Cab from Navi Mumbai airport to Lonavala offers direct and convenient travel after flight arrival. This service ensures timely pickup and smooth highway travel. Experienced drivers enhance safety. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Navi Mumbai Airport to Lonavala",
    description: "Taxi from Navi Mumbai airport to Lonavala provides dependable intercity travel with professional drivers. This service ensures smooth journeys with comfortable vehicles. Ideal for families and tourists. It guarantees reliability."
  },
  {
    name: "Book Cab Navi Mumbai Airport to Lonavala",
    description: "Book cab Navi Mumbai airport to Lonavala with easy online booking and instant confirmation. Customers can select vehicle type, pickup time, and location. Transparent pricing ensures convenience. It simplifies travel planning."
  },
  {
    name: "Online Cab Booking Navi Mumbai Airport to Lonavala",
    description: "Online cab booking Navi Mumbai airport to Lonavala provides a fast and convenient way to reserve your ride. Secure payment and instant confirmation enhance booking experience. Multiple vehicle options are available. It ensures hassle-free booking."
  },
  {
    name: "Best Cab Navi Mumbai Airport to Lonavala",
    description: "Best cab Navi Mumbai airport to Lonavala ensures top-quality vehicles, professional drivers, and excellent service. This service focuses on comfort, safety, and punctuality. It guarantees a premium travel experience."
  },
  {
    name: "Cheapest Cab Navi Mumbai Airport to Lonavala",
    description: "Cheapest cab Navi Mumbai airport to Lonavala offers budget-friendly travel options without compromising comfort. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical travel."
  },
  {
    name: "Reliable Taxi Navi Mumbai Airport to Lonavala",
    description: "Reliable taxi Navi Mumbai airport to Lonavala provides dependable transportation with verified drivers and well-maintained vehicles. This service ensures timely pickups and smooth travel. It guarantees a safe and comfortable journey."
  }
],

tableData: [
  ["Navi Mumbai to Lonavala Cab", "Navi Mumbai to Lonavala Cab Fare"],
  ["Navi Mumbai Airport to Lonavala Cabs", "Navi Mumbai Airport to Lonavala Cab"],
  ["Navi Mumbai Airport to Lonavala Taxi", "Cab from Navi Mumbai Airport to Lonavala"],
  ["Taxi from Navi Mumbai Airport to Lonavala", "Book Cab Navi Mumbai Airport to Lonavala"],
  ["Online Cab Booking Navi Mumbai Airport to Lonavala", "Best Cab Navi Mumbai Airport to Lonavala"],
  ["Cheapest Cab Navi Mumbai Airport to Lonavala", "Reliable Taxi Navi Mumbai Airport to Lonavala"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai Airport to Lonavala Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable cab service from Navi Mumbai Airport to Lonavala, perfect for weekend trips, family travel, and hill station getaways."
  },
  {
    WhyChooseheading: "On-Time Airport Pickup with Flight Tracking",
    WhyChoosedescription: "We track flight timings to ensure timely pickup even in case of delays, providing a hassle-free airport transfer experience."
  },
  {
    WhyChooseheading: "Experienced Ghat Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained in Mumbai–Lonavala ghat routes, ensuring safe driving and smooth travel through hilly roads."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport to Lonavala cab service operates round the clock for flexible travel anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and sanitized regularly for a comfortable ride."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Hill Station Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for reliable airport to Lonavala cab service with punctual drivers and smooth experience."
  }
]

};

const faqData = [
  { question: "Do you provide Navi Mumbai Airport to Lonavala cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Navi Mumbai Airport to Lonavala." },
  { question: "What is the distance between Navi Mumbai Airport and Lonavala?", answer: "The distance is approximately 70 to 90 km and takes around 1.5 to 2.5 hours depending on traffic." },
  { question: "What is the cab fare for this route?", answer: "Cab fares typically start from ₹1200 to ₹2500 depending on vehicle type and package." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip cab services." },
  { question: "Do you track flight delays?", answer: "Yes, we track flights to ensure timely pickup." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep drop in Lonavala?", answer: "Yes, we provide drop to hotel, villa, or any location in Lonavala." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Joshi",
    feedback: "The Navi Mumbai Airport to Lonavala cab with Royal Route Cabs was very comfortable and scenic. The driver was punctual and the ride felt smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "Great experience traveling from Navi Mumbai Airport to Lonavala. The cab was clean, and the journey was relaxing and well-managed by Royal Route Cabs.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Lonavala Cab",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-airport-to-lonavala-cab.jpg", // replace if needed
  "description": "Book Navi Mumbai Airport to Lonavala cab service with Royal Route Cabs for safe, comfortable, and affordable hill station travel. Available 24x7 with sedan, SUV, Innova, Ertiga, and premium vehicles for one-way and round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999", // approx starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-airport-to-lonavala-cab"
  }
};









  return (
    <div>
<Helmet>
  <title>Navi Mumbai Airport to Lonavala Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport to Lonavala cab with Royal Route Cabs. Enjoy safe and affordable hill station travel with 24x7 taxi service, professional drivers, and comfortable cars."
  />

  <meta
    name="keywords"
    content="navi mumbai to lonavala cab, navi mumbai airport to lonavala cabs, navi mumbai airport to lonavala cab, navi mumbai airport to lonavala taxi, cab from navi mumbai airport to lonavala, taxi from navi mumbai airport to lonavala, navi mumbai airport to lonavala cab fare, book cab navi mumbai airport to lonavala, online cab booking navi mumbai airport to lonavala, best cab navi mumbai airport to lonavala, cheapest cab navi mumbai airport to lonavala, reliable taxi navi mumbai airport to lonavala, one way cab navi mumbai airport to lonavala"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/77.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairporttolonavalacab;